import { render, staticRenderFns } from "./FooterMenu.vue?vue&type=template&id=8be8889e&scoped=true"
import script from "./FooterMenu.vue?vue&type=script&lang=js"
export * from "./FooterMenu.vue?vue&type=script&lang=js"
import style0 from "./FooterMenu.vue?vue&type=style&index=0&id=8be8889e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be8889e",
  null
  
)

export default component.exports